import { createFileRoute } from '@tanstack/react-router'
import { Main } from '@/components/layout/main'
import { FactorSheet } from '@/features/orders/components/factor-sheet'

// The factor accounting uploaded, on paper. Any desk that may open the
// order may print it; the API logs which sheet left the printer.
function FactorPrintPage() {
  const { orderId } = Route.useParams()

  return (
    <Main>
      <FactorSheet orderId={orderId} />
    </Main>
  )
}

export const Route = createFileRoute('/_authenticated/orders/factor/$orderId')({
  component: FactorPrintPage,
})
